import React from "react";
import { LegalShell, H2, P, UL } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy" updated="June 2026" testid="privacy-page">
      <P>iYeneh Connect, a service operated by Capital Defense Institute LLC ("iYeneh", "we", "us"), operates a global communications, broadcasting and digital-services platform available at iYeneh.com and as an installable app. This Privacy Policy explains what information we collect, how we use it, and the choices you have. By creating an account or using our services, you agree to this policy.</P>

      <H2>Information We Collect</H2>
      <UL>
        <li><strong>Account details</strong> — your name, email address, mobile number (verified by SMS OTP), and password.</li>
        <li><strong>Profile & preferences</strong> — business details, marketing opt-in and WhatsApp opt-in choices, and communication preferences.</li>
        <li><strong>Wallet & billing</strong> — top-ups, purchases, subscriptions and transaction history. Card and payment details are handled by our PCI-compliant payment processors and are not stored by us.</li>
        <li><strong>Usage & service data</strong> — calls, messages, meetings, broadcasts, eSIM and number activity generated when you use the platform.</li>
        <li><strong>Device & technical data</strong> — IP address, device type, browser and app version, and diagnostic logs.</li>
        <li><strong>Third-party sign-in</strong> — if you connect an account such as Facebook or Google, we receive basic profile information (name, email, profile picture, and account ID) that you authorize.</li>
      </UL>

      <H2>How We Use Your Information</H2>
      <UL>
        <li>To provide, operate and secure the services you request (calling, messaging, meetings, wallet, eSIM, business tools).</li>
        <li>To verify your identity and mobile number and to prevent fraud and abuse.</li>
        <li>To process payments, wallet top-ups and subscriptions.</li>
        <li>To send service messages and, where you have opted in, marketing communications by email, SMS or WhatsApp. You can opt out at any time (every SMS includes "Reply STOP", and your profile has marketing and WhatsApp toggles).</li>
        <li>To improve our products, provide support and comply with legal obligations.</li>
      </UL>

      <H2>How We Share Information</H2>
      <P>We do not sell your personal information. We share it only with:</P>
      <UL>
        <li><strong>Service providers</strong> who help us run the platform — licensed telecom carriers, payment processors, email delivery services and SI providers — strictly to deliver the services you use.</li>
        <li><strong>Legal and safety</strong> recipients when required by law, regulation or to protect our users and platform.</li>
        <li><strong>Business transfers</strong> in the event of a merger, acquisition or sale of assets, subject to this policy.</li>
      </UL>

      <H2>Data Retention</H2>
      <P>We keep your information for as long as your account is active or as needed to provide services, comply with legal, tax and regulatory requirements, resolve disputes and enforce our agreements. You can request deletion at any time (see below).</P>

      <H2>Your Rights & Choices</H2>
      <UL>
        <li>Access, correct or update your profile information from within the app.</li>
        <li>Opt out of marketing at any time via your profile toggles or by replying STOP to SMS.</li>
        <li>Request a copy or deletion of your personal data (see the Data Deletion page).</li>
      </UL>

      <H2>Security</H2>
      <P>We use encryption in transit, access controls and reputable processors to protect your data. No method of transmission or storage is completely secure, but we work continuously to safeguard your information.</P>

      <H2>Children</H2>
      <P>Our services are not directed to children under 13 (or the minimum age required in your country), and we do not knowingly collect their data.</P>

      <H2>International Users</H2>
      <P>iYeneh serves a global community. Your information may be processed in countries other than your own, with appropriate safeguards in place.</P>

      <H2>Changes to This Policy</H2>
      <P>We may update this policy from time to time. Material changes will be posted on this page with a new "Last updated" date.</P>

      <H2>Contact Us</H2>
      <P>Questions or requests about your privacy? Email <a className="text-white underline" href="mailto:support@iyeneh.com">support@iyeneh.com</a> or reach our support team on WhatsApp at <a className="text-white underline" href="https://wa.me/12029403399" target="_blank" rel="noreferrer">+1 202 940 3399</a>.</P>
    </LegalShell>
  );
}
